export const FIELDS_CONFIG = [
  {
    id: 'facilitating_location',
    label: 'Facilitating Location',
    valueType: 'link',
    valueLinkText:
      'automatically fetched from the Facilitating Location file, to edit go',
    valueLinkUrl: '/facilitating-locations',
    actionOnNull: 'move_to_pending',
  },
  {
    id: 'lanes',
    label: 'Lane(s)',
    valueType: 'link',
    valueLinkText: 'automatically fetched from the Lane(s) file, to edit go',
    valueLinkUrl: '/lanes',
    actionOnNull: 'deny',
  },
  {
    id: 'sales_channel',
    label: 'Sales Channel',
    valueType: 'multiselect',
    valueOptions: [
      { key: 'live_auction', text: 'Live Auction', value: 'live_auction' },
      { key: 'online', text: 'Online', value: 'online' },
    ],
    selectedValues: ['live_auction', 'online'],
    actionOnNull: 'move_to_pending',
  },
  {
    id: 'pickup_location',
    label: 'Pickup Location',
    valueType: 'multiselect',
    valueOptions: [],
    selectedValues: [],
    actionOnNull: 'move_to_pending',
  },
  {
    id: 'sale_type',
    label: 'Sale Type',
    valueType: 'multiselect',
    valueOptions: [
      { key: 'absolute', text: 'Absolute', value: 'absolute' },
      { key: 'if_bid', text: 'If Bid', value: 'if_bid' },
    ],
    selectedValues: ['absolute', 'if_bid'],
    actionOnNull: 'move_to_pending',
  },
  {
    id: 'vehicle_location',
    label: 'Vehicle Location',
    valueType: 'multiselect',
    valueOptions: [],
    selectedValues: [],
    actionOnNull: 'move_to_pending',
  },
  {
    id: 'vehicle_health_score',
    label: 'Vehicle Health Score',
    valueType: 'buckets',
    buckets: [
      { label: 'Bucket 1, minimal accepted value:', value: 70 },
      { label: 'Bucket 2, minimal accepted value:', value: 70 },
      { label: 'Bucket 3, minimal accepted value:', value: 70 },
      { label: 'Bucket 4, minimal accepted value:', value: 70 },
      { label: 'Bucket 5, minimal accepted value:', value: 70 },
    ],
    actionOnNull: 'move_to_pending',
  },
  {
    id: 'business_unit',
    label: 'Business Unit',
    valueType: 'include_multiselect',
    includeExclude: 'include',
    valueOptions: [],
    selectedValues: [],
    actionOnNull: 'move_to_pending',
  },
  {
    id: 'make_model',
    label: 'Make/Model',
    valueType: 'link',
    valueLinkText:
      'automatically fetched from the Make/Model to Exclude file, to edit go',
    valueLinkUrl: '/make-model',
    actionOnNull: 'move_to_pending',
  },
  {
    id: 'fuelTypeEligibilityRule',
    label: 'Fuel Type',
    valueType: 'multiselect',
    actionOnNull: 'move_to_pending',
  },
  {
    id: 'inventory_source_buyer_group',
    label: 'Inventory Source/Buyer Group',
    valueType: 'multiselect',
    valueOptions: [],
    selectedValues: [],
    actionOnNull: 'move_to_pending',
  },
  {
    id: 'cr_grade',
    label: 'CR Grade, minimal accepted value',
    valueType: 'number_input',
    numberValue: 1,
    actionOnNull: 'move_to_pending',
  },
  {
    id: 'cr_type',
    label: 'CR Type',
    valueType: 'static_text',
    staticText: 'include only Manheim-classified CRs',
    actionOnNull: 'ignore_rule',
  },
  {
    id: 'crossover',
    label: 'Crossover',
    valueType: 'static_text',
    staticText: 'do not allow crossover',
    actionOnNull: 'move_to_pending',
  },
  {
    id: 'mmrEligibilityRule',
    label: 'MMR Eligibility',
    valueType: 'range',
    rangeMin: 0,
    rangeMax: 200000,
    actionOnNull: 'ignore_rule',
  },
  {
    id: 'pricing_percent_mmr',
    label: 'Pricing – % of MMR – post-sale',
    valueType: 'range',
    rangeMin: 80,
    rangeMax: 120,
    actionOnNull: 'deny',
  },
  {
    id: 'saPricingPercentOfMmrRule',
    label: 'SA Pricing % of MMR',
    valueType: 'range',
    rangeMin: 40,
    rangeMax: 110,
    actionOnNull: 'ignore_rule',
  },
  {
    id: 'saPricingDollarOverMmrRule',
    label: 'SA Pricing $ over MMR',
    valueType: 'number_input',
    numberValue: 3500,
    actionOnNull: 'ignore_rule',
  },
  {
    id: 'saLightEligibilityRule',
    label: 'SA Light Color Eligibility',
    valueType: 'multiselect',
    options: ['GREEN', 'YELLOW', 'RED'],
    actionOnNull: 'ignore_rule',
  },
  {
    id: 'title',
    label: 'Title',
    valueType: 'include_exclude_multiselect',
    includeExclude: 'exclude',
    valueOptions: [{ key: 'salvage', text: 'Salvage', value: 'salvage' }],
    selectedValues: ['salvage'],
    actionOnNull: 'ignore_rule',
  },
  {
    id: 'model_year',
    label: 'Model Year',
    valueType: 'condition_builder',
    conditions: [
      {
        includeExclude: 'include',
        comparison: 'gte',
        field: 'Model Year',
        value: 2015,
      },
    ],
    allowAddCondition: true,
    actionOnNull: 'move_to_pending',
  },
  {
    id: 'odometer_less_than',
    label: 'Odometer, less then',
    valueType: 'number_input',
    numberValue: 0,
    actionOnNull: 'deny',
  },
  {
    id: 'autocheck_activity_codes',
    label: 'Autocheck Activity Codes',
    valueType: 'search_input',
    searchPlaceholder: 'Start typing to search',
    searchValue: '',
    allowAddCondition: true,
    actionOnNull: 'ignore_rule',
  },
  {
    id: 'autocheck_odometer_rollback',
    label: 'Autocheck Odometer rollback flag',
    valueType: 'static_text',
    staticText: 'do not allow odometer rollback flag',
    actionOnNull: 'move_to_pending',
  },
  {
    id: 'announcement_keywords',
    label: 'Announcement Keywords/F5 Notes',
    valueType: 'search_input',
    searchPlaceholder: 'Start typing to search',
    searchValue: '',
    allowAddCondition: true,
    actionOnNull: 'move_to_pending',
  },
  {
    id: 'disclosure_keywords',
    label: 'Disclosure Keywords',
    valueType: 'search_input',
    searchPlaceholder: 'Start typing to search',
    searchValue: '',
    allowAddCondition: true,
    actionOnNull: 'move_to_pending',
  },
  {
    id: 'vin_blacklist',
    label: 'VIN Blacklist',
    valueType: 'link',
    valueLinkText: 'automatically fetched from the VIN Blacklist, to edit go',
    valueLinkUrl: '/vin-blacklist',
    actionOnNull: 'ignore_rule',
  },
  {
    id: 'lights',
    label: 'Lights',
    valueType: 'multiselect',
    valueOptions: [],
    selectedValues: [],
    actionOnNull: 'move_to_pending',
  },
  {
    id: 'traStatusEligibilityRule',
    label: 'TRA Status',
    valueType: 'static_text',
    staticText: 'do not allow TRA',
    actionOnNull: 'ignore_rule',
  },
  {
    id: 'as_is_status',
    label: 'As-Is Status',
    valueType: 'static_text',
    staticText: 'do not allow As-Is',
    actionOnNull: 'ignore_rule',
  },
  {
    id: 'lemon_law',
    label: 'Lemon Law',
    valueType: 'static_text',
    staticText: 'do not allow Lemon Law',
    actionOnNull: 'deny',
  },
  {
    id: 'vehicle_problem_file',
    label: 'Vehicle Problem File',
    valueType: 'search_input',
    searchPlaceholder: 'Start typing to search',
    searchValue: '',
    allowAddCondition: true,
    actionOnNull: 'deny',
  },
  {
    id: 'times',
    label: 'Times (see 3.1 PSI policy)',
    valueType: 'time_picker',
    timeCondition: 'after',
    timeHour: 5,
    timeMinute: 0,
    timePeriod: 'PM',
    timeZone: 'EST',
    allowAddCondition: true,
    actionOnNull: 'ignore_rule',
  },
  {
    id: 'certification_status',
    label: 'Certification status',
    valueType: 'empty',
    actionOnNull: 'move_to_pending',
  },
];

// Maximum number of conditions that can be added per field
// Set to Infinity for unlimited conditions, or a number (e.g., 5) to limit
export const MAX_CONDITIONS_PER_FIELD = 5;
